import React from "react";
import { Chip, ChipProps, ChipList } from "@progress/kendo-react-buttons";

export interface TagData {
  name?: string;
  text?: string;
  value?: string;
  icon?: string;
  avatar?: {};
  tags?: string[];
}

export class DataModel {
  name: string;
  numberOfPlayers: string;
  bestFor: string;
  age: string;
  mechanism: string;
  thematics: string;
  time: string;
  level: number;
}

const Item = (props: DataModel) => {

  const getthemeColor = (number: TagData) => {
    if (!number.text.startsWith('Nehézség:')) {
      return "base";
    }

    const x = parseFloat(number.text.split(': ')[1].replace(',', '.'));
    //console.log(x);
    switch (true) {
      case (x < 2):
        return "success";
        break;
      case (x < 3.5):
        return "warning";
        break;
      case (x < 4):
        return "warning";
        break;
      default:
        return "error";
        break;
    }
  };

  const getTags = (m: DataModel): TagData[] => {
    return [
      { text: `Játékosok: ${m.numberOfPlayers}` },
      { text: `Kor: ${m.age}` },
      { text: `Típus: ${m.mechanism}` },
      { text: `Téma: ${m.thematics}` },
      { text: `Játékidő: ${m.time}` },
      { text: `Nehézség: ${m.level}` },
    ];
  };

  let tagDataList = getTags(props);

  const tagChip = (props: ChipProps) => {
    // Winter!!!!
    return (
      <Chip
        {...props}
        size={"small"}
        themeColor={getthemeColor(props.dataItem)}

        fillMode={"solid"}
        rounded={"full"}
        removable={false}
      // avatar={props.dataItem.avatar}
      // disabled={winterMonths.some((f) => f === props.dataItem.value)}
      // style={{ backgroundColor: getthemeColor(props.dataItem) }}
      />
    );
  };

  // let tagElements = props.tags.map((tag, index) => { return React.createElement('li', { key: index }, tag); });

  return (
    <div className="item">
      {/* <div className="logo">
        <img src={props.logo} alt={props.name} />
      </div> */}
      <div className="name">
        <p>{props.name}</p>
        {/* <div className="tags">{props.tags.join(", ")}</div> */}
        {/* {React.createElement('ul', null, tagElements)} */}
        <div>
          <ChipList
            defaultData={tagDataList}
            data={tagDataList}
            selection="multiple"
            chip={tagChip}
          />
        </div>
      </div>
    </div>
  );
};

export default Item;
